
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.999 16.327a1.5 1.5 0 001.5-1.5V1.5a1.5 1.5 0 10-3 0v13.327a1.5 1.5 0 001.5 1.5z"}}),_c('path',{attrs:{"d":"M21.388 4.721a1.502 1.502 0 00-1.959.814 1.502 1.502 0 00.814 1.959c4.214 1.738 6.937 5.791 6.937 10.325C27.18 23.984 22.164 29 15.999 29s-11.18-5.016-11.18-11.181c0-4.543 2.723-8.602 6.937-10.338a1.499 1.499 0 10-1.143-2.773A14.144 14.144 0 001.82 17.82C1.818 25.639 8.18 32 15.999 32c7.82 0 14.181-6.361 14.181-14.181 0-5.753-3.452-10.895-8.792-13.098z"}})])
          )
        }
      }
    